export const INSURANCE_SETTINGS_STATUSES = {
    SERVICEABLE: 'Serviceable',
    UNSERVICEABLE: 'Unserviceable',
    PENDING_INVESTIGATION: 'Pending Investigation',
};
